import { useEffect, useRef } from "react";

/** Generic hook to support "prevProps" like logic. */
export const usePrevious = <T,>(value: T): T | undefined => {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
